import { FC } from "react";
import clsx from "clsx";

import { Link } from "react-router-dom";

import { usePageData } from "../../../core/PageData";

export const DefaultTitle: FC = () => {
	const { pageTitle, pageDescription, pageBreadcrumbs } = usePageData();
	return (
		<div className="page-title d-flex justify-content-center flex-column me-5">
			{pageTitle && (
				<h1 className="d-flex flex-column text-dark fw-bolder fs-3 mb-0">
					{pageTitle}
					{pageDescription && (
						<small className="text-primary fs-7 fw-bold pt-1">{pageDescription}</small>
					)}
				</h1>
			)}

			{pageBreadcrumbs && pageBreadcrumbs.length > 0 && (
				<ul className="breadcrumb breadcrumb-line fw-bold fs-7">
					{Array.from(pageBreadcrumbs).map((item, index) => (
						<li
							className={clsx("breadcrumb-item", {
								"text-dark": !item.isSeparator && item.isActive,
								"text-muted": !item.isSeparator && !item.isActive,
							})}
							key={`${item.path}${index}`}
						>
							{!item.isSeparator ? (
								<Link className="text-muted text-hover-primary" to={item.path}>
									{item.title}
								</Link>
							) : (
								<span className="bullet bg-gray-200 w-5px h-2px"></span>
							)}
						</li>
					))}
					<li className="breadcrumb-item text-dark">{pageTitle}</li>
				</ul>
			)}
		</div>
	);
};
